import { Box, IconButton, Link, Modal, Text, TextField } from '@hopskipdrive/react-components';
import { Drawer, Select } from '@mui/material';
import styled from 'styled-components';

import { colorPalette, colorTokens } from '../../../shared/components/variables';

export const SelectClearButton = styled(IconButton)`
  padding: 4px;
  position: absolute;
  right: 32px;
  opacity: 0;
  pointer-events: none;
`;

export const PlaceholderText = styled(Text)`
  color: ${colorTokens.secondary.disabled};
  font-size: 13px;
`;

export const StyledFormLabel = styled.label`
  color: ${colorTokens.text.secondary};
  font-size: 14px;
  font-weight: 500;
  flex-basis: 100px;
  flex-shrink: 0;
  margin-top: 10px;
  margin-right: 24px;
`;

export const StyledSelect = styled(Select)`
  && {
    &:hover {
      .clearBtn {
        opacity: 1;
        pointer-events: all;
      }
    }
  }
`;

export const StyledCheckboxField = styled(Box)`
  cursor: pointer;
  display: flex;
  align-items: center;

  svg {
    color: ${colorTokens.info.main}!important;
  }

  label {
    user-select: none;
    cursor: pointer;
    flex-basis: unset;
    flex-shrink: unset;
    color: ${colorTokens.text.primary};
    margin-top: 0;
  }
`;

export const StyledAccountField = styled(Box)`
  && {
    display: flex;
    width: 100%;
    align-items: center;

    .MuiFormControl-root {
      input {
        -webkit-text-fill-color: ${colorTokens.text.primary} !important;
      }
    }

    & > p {
      display: block;
      margin-left: 10px;
      padding: 5px 16px;
    }
  }
`;

export const StyledRideSlugField = styled(TextField)`
  && {
    input {
      -webkit-text-fill-color: ${colorTokens.text.primary} !important;
    }
  }
`;

export const StyledAccount = styled(Text)`
  display: inline-block;
  font-size: 14px;
  font-weight: 500;

  &::after {
    border-radius: 4px;
    color: ${colorTokens.text.contrast};
    padding: 3px 12px;
  }

  &.BToCAccount::after {
    content: 'B2C';
    background-color: ${colorTokens.primary.light};
  }

  &.BToBAccount::after,
  &.PublicPartnershipsAccount::after {
    content: 'B2B';
    background-color: ${colorTokens.background.black};
  }
`;

export const StyledAdminNotesField = styled(Box)`
  margin: 12px 0;
`;

export const StyledDrawer = styled(Drawer)`
  && {
    .MuiDrawer-paper {
      width: 600px;
    }
  }
`;

export const CloseButton = styled(Link)`
  color: ${colorTokens.text.secondary};

  &:hover {
    color: ${colorTokens.text.secondary};
  }
`;

export const StyledForm = styled.form`
  dl {
    justify-content: flex-start;
    margin: 14px 0;

    dt {
      width: 100px;
      align-self: flex-start;
      flex-shrink: 0;

      label {
        font-size: 14px;
        color: ${colorTokens.text.secondary};
      }
    }

    dd {
      flex-basis: 100%;
      margin-left: 24px;
    }
  }

  dl:last-child {
    dd {
      flex-grow: 1;
    }
  }
`;

export const StyledModalActions = styled(Modal.Actions)`
  padding-left: 0;
  padding-right: 0;
  flex-wrap: wrap;

  hr {
    margin-bottom: 20px;
  }

  .buttons {
    padding: 0 20px;
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

  .loader svg {
    color: ${colorPalette.white};
  }
`;

export const IncidentDetailsContainer = styled(Box)`
  background-color: ${colorTokens.tonal.light};
  padding: 12px;
  border-radius: 12px;
  margin-bottom: 14px;
`;
